import { AuthCredentialsRequestDTOCountryEnum } from "@app/api/generated-api";
import React, { ReactNode } from "react";
import IconKZ from "../../../icons/icon-kz.svg";
import IconBY from "../../../icons/icon-by.svg";
import IconRU from "../../../icons/icon-ru.svg";

export type RegionType = {
  [key in AuthCredentialsRequestDTOCountryEnum]: {
    mask: string;
    code: string;
    name: string;
    icon: ReactNode;
  };
};

export const regions: RegionType = {
  [AuthCredentialsRequestDTOCountryEnum.RU]: {
    mask: "999 999 99 99",
    code: "+7",
    icon: <IconRU />,
    name: "Россия",
  },
  [AuthCredentialsRequestDTOCountryEnum.BY]: {
    mask: "99 999 99 99",
    code: "+375",
    icon: <IconBY />,
    name: "Беларусь",
  },
  [AuthCredentialsRequestDTOCountryEnum.KZ]: {
    mask: "999 999 9999",
    code: "+7",
    icon: <IconKZ />,
    name: "Казахстан",
  },
};
